<template>
  <transition name="fade">
    <!-- <div  class="image-container" > -->
      <!-- <picture > -->
        <!-- <source media="(min-width: 1025px)" srcset="">
        <source media="(max-width: 1024px) and (orientation: landscape)" srcset=""> -->
        <!-- <source media="(max-width: 1024px) and (orientation: portrait)" :srcset="src"> -->
        <!-- <source media="(max-width: 576px)" :srcset="src.split('.')[0] + '-small.jpg'">  -->
        <img v-show="loaded && mounted" :src="src" :alt="alt" @load="onLoad" :width="width" :height="height">
      <!-- </picture> -->
    <!-- </div> -->
  </transition>
</template>

<script>
export default {
  name: 'LoadImage',
  props: {
    src: {
      type: String,
      required: true, 
    },
    alt: {
      type: String,
      required: false, 
    },
    fade: {
      type: Boolean,
      default: false, 
    }, 
    delay: {
      type: Number,
    },
    enter: {
      type: Boolean,
      default: true
    },
    width: Number,
    height: Number,
  },
  data() {
    return {
      loaded: false,
      mounted: false, 
    }
  },
  mounted() {
    this.mounted = true
  },
  methods: {
    onLoad() {
      this.loaded = true
    }
  }
}
</script>

<style lang="sass" scoped>
.fade-enter-active, .fade-leave-active
  transition: opacity 0.8s ease-in

.fade-enter, .fade-leave-to   
  opacity: 0
</style>
